module.exports = __webpack_public_path__ + "img/547.44752fd0.jpg";